// Neon Auth client configuration
// Reference: https://neon.com/docs/auth/quick-start/react

import { createAuthClient } from '@neondatabase/neon-js/auth';

// Create the auth client with the Neon Auth URL
export const authClient = createAuthClient(
  import.meta.env.VITE_NEON_AUTH_URL
);

export default authClient;
